export default {
  SHERLOCK_POINT_PRODUCTS: "sherlockPointProducts",
  SHERLOCK_POINT_STATUS: "sherlockPointStatus",
  SHERLOCK_POINT_HISTORY: "sherlockPointHistory",

  SET_SHERLOCK_ESTATE_OWNER_PROPERTY_LIST: "setSherlockEstateOwnerPropertyList",
  SET_SHERLOCK_ESTATE_ESTATE_QUERY_LIST: "setSherlockEstateEstateQueryList",
  SET_SHERLOCK_ESTATE_ADDRESS_SEARCH_LIST: "setSherlockEstateAddressSearchList",

  SET_SHERLOCK_ESTATE_OWNER_PROPERTY_DETAIL: "setSherlockEstateOwnerPropertyDetail",

  // NZSC-3047/3050: 구독
  SET_SHERLOCK_SUBSCRIPTION_INFO: "setSherlockSubscriptionInfo",
  SET_SHERLOCK_SUBSCRIPTION_PLANS: "setSherlockSubscriptionPlans",
};

/**
 * NZSC-3047 구독 응답 초기 상태.
 * BE 미구독 응답: hasSubscription=false, status='none', 나머지 null.
 */
export const initialSubscriptionInfoState = {
  /** @type {boolean} 구독 보유 여부 */
  hasSubscription: false,
  /** @type {'none'|'구독중'|'해지예약'|'구독중지'|'결제연체'} 응답 노출 상태 */
  status: "none",
  /** @type {{ productCode: string, productName: string, totalPrice: number } | null} 현재 플랜 요약 */
  plan: null,
  /** @type {Object | null} 사용량 (multiDwelling/register/delinquency 각각 used/limit/remaining) */
  usage: null,
  /** @type {string | null} 결제 주기 시작 (ISO8601) */
  currentPeriodStart: null,
  /** @type {string | null} 결제 주기 종료 (ISO8601) */
  currentPeriodEnd: null,
  /** @type {string | null} 다음 자동결제 일시 (ISO8601) */
  nextBillingAt: null,
  /** @type {Object | null} 다운그레이드 예약 정보 */
  pendingDowngrade: null,
};

/**
 * @typedef {'sherlock_point'} PointProductsType
 */
export const initialPointProductsState = {
  /** @type {Date | null} 생성일 */
  createDate: null,
  /** @type {Date | null} 삭제일 */
  deleteDate: null,
  /** @type {number | null} 표시 가격 */
  displayPrice: null,
  /** @type {string | null} 메타데이터 */
  metadata: null,
  /** @type {Date | null} 수정일 */
  modifyDate: null,
  /** @type {number | null} 포인트 */
  point: null,
  /** @type {string | null} 상품 클래스 */
  productClass: null,
  /** @type {string | null} 상품 코드 */
  productCode: null,
  /** @type {string | null} 상품 이름 */
  productName: null,
  /** @type {number | null} 셜록 상품 고유번호 */
  sherlockProductSeq: null,
  /** @type {number | null} 총 가격 */
  totalPrice: null,
  /** @type {number | null} 부가세 */
  vatAmount: null,
  /** @type {number | null} 표시 순서 */
  displayOrder: null,
  /** @type {number | null} 보너스 포인트 */
  bonusPoint: null,
  /** @type {boolean | null} 활성 여부 */
  activeYn: null,
};
export const initialPointProductsItemState = {
  ...initialPointProductsState,
};

/**
 * @typedef {'sherlock_point'} PointStatusType
 */
export const initialPointStatusState = {
  /** @type {number | null} 리포트 이용권 개수 */
  reportTicketCount: null,
  /** @type {number | null} 셜록 포인트 금액 */
  sherlockPointAmount: null,
  /** @type {number | null} 셜록 보너스 포인트 금액 */
  sherlockBonusPointAmount: null,
};

export const initialPointHistoryItemState = {
  /** @type {Object | null} 그룹 */
  group: {
    groupSeq: null,
    grouped: false,
    items: [],
  },
  usage: {
    action: null,
    createDate: null,
    historySeq: null,
    plusMinus: null,
    pointAmount: null,
    bonusPointAmount: null,
    itemSeq: null,
  },
};

export const initialOwnerPropertyListItemState = {
  /** @type {Date | null} 등록일 */
  createDate: null,

  /** @type {Date | null} 수정일 */
  modifyDate: null,

  /** @type {Object | null} 소유자 */
  owner: {
    /** @type {string | null} 소유자 ID */
    ownerId: null,

    /** @type {string | null} 소유자 이름 */
    ownerName: null,

    /** @type {string | null} 소유자 주민등록번호 */
    ownerRegno: null,
  },

  /** @type {number | null} 소유자 속성 조회 고유번호 */
  ownerPropertyQuerySeq: null,

  /** @type {boolean | null} 진행 여부 */
  progressYn: null,

  /** @type {boolean | null} 성공 여부 */
  successYn: null,
};

export const initialEstateQueryListItemState = {
  /** @type {Object | null} 등기부 */
  estateFile: {
    /** @type {string | null} 건축물 */
    buildingDoc: null,
    /** @type {string | null} 등기부 */
    estateDoc: null,
  },
  /** @type {Object | null} 등기부 조회 */
  estateQuery: {
    /** @type {string | null} 주소 */
    address: null,
    /** @type {number | null} 등기부 조회 고유번호 */
    estateQuerySeq: null,
    /** @type {string | null} 등기부 조회 타입 */
    estateQueryType: null,
    /** @type {boolean | null} 존재 여부 */
    exists: null,
    /** @type {boolean | null} 진행 여부 */
    progressYn: null,
    /** @type {boolean | null} 성공 여부 */
    successYn: null,
    /** @type {string | null} 고유번호 */
    uniqueNo: null,
  },
  /** @type {Object | null} 등기부 결과 */
  estateResult: {
    /** @type {boolean | null} 존재 여부 */
    exists: null,
  },
};

export const initialAddressSearchListItemState = {
  addressSearchQueries: [],
};
